export default {
  items: [],
  total: 0,
}
